import { LayoutDashboard, BookOpen, ShoppingCart, Gift, Lightbulb } from "lucide-react";

export const STUDENT_NAV = [
  { key: "home", label: "Dashboard", to: "/student", icon: LayoutDashboard },
  { key: "solutions", label: "Solved Paper", to: "/student/solutions", icon: Lightbulb },
  { key: "papers", label: "Buy Papers", to: "/student/plans", icon: BookOpen },
  { key: "checkout", label: "Checkout", to: "/student/checkout", icon: ShoppingCart },
  { key: "referral", label: "Referral", to: "/student/referrals", icon: Gift },
];
